export default Object.freeze(({'WholeNumber': "0", 'Text': "@", 'Date': 'dd-mm-yy h:mm;@', "DecimalNumber":"0.000"}));